/**
 * Normalizes a Google place into the flat address components the form autofill
 * maps onto its own fields. Handles BOTH the legacy `PlaceResult`
 * (address_components/long_name/formatted_address/geometry.location) and the new
 * Places `Place` (addressComponents/longText/formattedAddress/location). Pure
 * function — unit-testable without the SDK (lat/lng accept number or function).
 */
function componentLongName(components, type) {
  const match = (components || []).find(c => (c.types || []).includes(type));
  if (!match) return '';
  return match.long_name || match.longText || match.short_name || match.shortText || '';
}

function coord(value) {
  if (typeof value === 'function') return value();
  return typeof value === 'number' ? value : null;
}

export function parseGooglePlace(place) {
  const components = place?.address_components || place?.addressComponents || [];
  const location = place?.geometry?.location || place?.location;
  return {
    number: componentLongName(components, 'street_number'),
    street: componentLongName(components, 'route'),
    colonia:
      componentLongName(components, 'sublocality_level_1') ||
      componentLongName(components, 'sublocality') ||
      componentLongName(components, 'neighborhood'),
    postal_code: componentLongName(components, 'postal_code'),
    city:
      componentLongName(components, 'locality') ||
      componentLongName(components, 'administrative_area_level_2'),
    state: componentLongName(components, 'administrative_area_level_1'),
    country: componentLongName(components, 'country'),
    formatted: place?.formatted_address || place?.formattedAddress || '',
    lat: location ? coord(location.lat) : null,
    lng: location ? coord(location.lng) : null,
  };
}
